import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { AuthenticationService, Configuration, isNullOrUndefined, SiteService } from '@sla-ng/core';
import { catchError, distinctUntilChanged, map, Observable, of, tap } from 'rxjs';
import { ISlairUser } from '../models/slair-user.model';
import { BffResource } from '../resources/bff.resource';

@Injectable({
    providedIn: 'root',
})
export class SlairAuthenticationService extends AuthenticationService<ISlairUser> {

    public authBean: ISlairUser = null;
    private userRoles: string[] = [];

    constructor(
        @Optional()
        protected myConfiguration: Configuration,
        protected override myHttpClient: HttpClient,
        protected override mySiteService: SiteService,
        protected myBffResource: BffResource,
    ) {
        super(myHttpClient, mySiteService, myConfiguration);
    }

    public override async init(): Promise<void> {
        /*
        Overriding this function is needed because otherwise, a user might be loaded from LocalStorage
        which we do not want in this case
         */
        this.subject.subscribe((authBean: ISlairUser) => {
            this.authBean = authBean;

        });
        this.user$ = this.subject.asObservable();
        this.isLoggedIn$ = this.user$.pipe(map((user) => !!user), distinctUntilChanged());
        return Promise.resolve();
    }

    public override isLoginValid(): Observable<boolean> {
        if (!isNullOrUndefined(this.authBean)) {
            return of(true);
        }
        return this.getStatus().pipe(map(user => !isNullOrUndefined(user)));
    }

    public override login(_username: string, _password: string): Observable<ISlairUser> {
        this.myBffResource.login();
        return this.getStatus();
    }

    public override userHasRoles(roles: string[] | string): boolean {
        if (isNullOrUndefined(roles)) {
            return true;
        }
        if (typeof roles === 'string') {
            return this.userRoles.indexOf(roles) !== -1;
        }
        for (const role of roles) {
            if (this.userRoles.indexOf(role) !== -1) {
                return true;
            }
        }
        return false;
    }

    public override getStatus(): Observable<ISlairUser> {
        return this.myBffResource.getSelf().pipe(
            tap((user) => {
                this.updateUser(user);
            }),
            catchError(() => {
                this.updateUser(null);
                return of(null);
            }),
        );
    }

    public override logout(): Observable<void> {
        this.myBffResource.logout();
        this.subject.next(null);
        return of();
    }

    public setRoles(roles: string[]): void {
        this.userRoles = [ ...roles ];
        this.updateUser(this.subject.value);
    }

    private updateUser(user: ISlairUser): void {
        this.subject.next(user);
    }


}
